import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import { store } from "@/store/store";
// import vuetify from "./plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";

import { sync } from "vuex-router-sync";
import BottomScroll from "vue-bottom-scroll-listener";

// import from /mixins
import Mixins from "@/mixins/Mixins";
import StoreGetter from "@/mixins/StoreGetter";

// import from components

import InfoBar from "@/components/InfoBar";
import AddButton from "./components/buttons/AddButton";
import ViewButton from "./components/buttons/ViewButton";
import SettingButton from "./components/buttons/SettingButton";
import CancelButton from "./components/buttons/CancelButton";
import EditButton from "./components/buttons/EditButton";
import DeleteButton from "./components/buttons/DeleteButton";
import ModuleButton from "./components/buttons/ModuleButton.vue";
import RemoveButton from "./components/buttons/RemoveButton";
import AssignButton from "./components/buttons/AssignButton";
import DownloadButton from "./components/buttons/DownloadButton";
import DownloadExcelButton from "./components/buttons/DownloadExcelButton";
import DownloadPDFButton from "./components/buttons/DownloadPDFButton";
import DownloadItemButton from "./components/buttons/DownloadItemButton";
import DownloadTemplateButton from "./components/buttons/DownloadTemplateButton";
import PrintButton from "./components/buttons/PrintButton";
import UpdateButton from "./components/buttons/UpdateButton";
import UploadButton from "./components/buttons/UploadButton";
import TemplateButton from "./components/buttons/TemplateButton";
import ManageButton from "./components/buttons/ManageButton";
import LogoutButton from "./components/buttons/LogoutButton";
import SubscribeButton from "./components/buttons/SubscribeButton";
import MultiDeleteButton from "./components/buttons/MultiDeleteButton";
import MultiAssignButton from "./components/buttons/MultiAssignButton";
import ActionDialog from "./components/dialog/ActionDialog";
import CustomizeDialog from "./components/dialog/CustomizeDialog";
import CancelDialog from "./components/dialog/CancelDialog";
import FullDialog from "./components/dialog/FullDialog";
import PrintDialog from "./components/dialog/PrintDialog";
import UploadPreviewDialog from "./components/dialog/UploadPreviewDialog";
import DeleteDialog from "./components/dialog/DeleteDialog";
import ConfirmDialog from "./components/dialog/ConfirmDialog";
import MessageDialog from "./components/dialog/MessageDialog";
import PageLoading from "./components/PageLoading";
import JtiExpansionPanel from "@/components/JtiExpansionPanel";
import JtiFilterPanel from "@/components/JtiFilterPanel";
import SearchField from "./components/fields/SearchField";
import RefreshButton from "@/components/buttons/RefreshButton";
import IconBase from "@/components/IconBase";
import IconHome from "@/components/icons/Home";
import IconCompany from "@/components/icons/Company";
import IconAccessCard from "@/components/icons/AccessCard";
import IconEmployee from "@/components/icons/Employee";
import IconDevice from "@/components/icons/Device";
import IconTerminal from "@/components/icons/Terminal";
import IconFuelStation from "@/components/icons/FuelStation";
import IconRoute from "@/components/icons/Route";
import IconBusType from "@/components/icons/BusType";
import IconVehicle from "@/components/icons/Vehicle";
import IconProject from "@/components/icons/Project";
import IconStop from "@/components/icons/Stop";
import IconPassengerType from "@/components/icons/PassengerType";
import IconSchedule from "@/components/icons/Schedule";
import IconSeats from "@/components/icons/Seat";
import IconLayout from "@/components/icons/Layout";

import IconBlank from "@/components/icons/BusBlank";
import IconSeat from "@/components/icons/BusSeat";
import IconDriver from "@/components/icons/BusDriver";
import IconDoor from "@/components/icons/BusDoor";
import IconToilet from "@/components/icons/BusToilet";

import NewJtiFilterPanel from "@/components/NewJtiFilterPanel";

Vue.mixin(Mixins);
Vue.mixin(StoreGetter);

Vue.config.productionTip = false;

Vue.component("info-bar", InfoBar);
Vue.component("bottom-scroll", BottomScroll);
Vue.component("add-button", AddButton);
Vue.component("refresh-button", RefreshButton);
Vue.component("view-button", ViewButton);
Vue.component("setting-button", SettingButton);
Vue.component("cancel-button", CancelButton);
Vue.component("edit-button", EditButton);
Vue.component("delete-button", DeleteButton);
Vue.component("module-button", ModuleButton);
Vue.component("remove-button", RemoveButton);
Vue.component("assign-button", AssignButton);
Vue.component("download-button", DownloadButton);
Vue.component("download-excel-button", DownloadExcelButton);
Vue.component("download-pdf-button", DownloadPDFButton);
Vue.component("download-item-button", DownloadItemButton);
Vue.component("download-template-button", DownloadTemplateButton);
Vue.component("print-button", PrintButton);
Vue.component("update-button", UpdateButton);
Vue.component("upload-button", UploadButton);
Vue.component("template-button", TemplateButton);
Vue.component("manage-button", ManageButton);
Vue.component("logout-button", LogoutButton);
Vue.component("subscribe-button", SubscribeButton);
Vue.component("multi-delete-button", MultiDeleteButton);
Vue.component("multi-assign-button", MultiAssignButton);
Vue.component("action-dialog", ActionDialog);
Vue.component("customize-dialog", CustomizeDialog);
Vue.component("cancel-dialog", CancelDialog);
Vue.component("full-dialog", FullDialog);
Vue.component("print-dialog", PrintDialog);
Vue.component("delete-dialog", DeleteDialog);
Vue.component("confirm-dialog", ConfirmDialog);
Vue.component("message-dialog", MessageDialog);
Vue.component("upload-preview-dialog", UploadPreviewDialog);
Vue.component("jti-expansion-panel", JtiExpansionPanel);
Vue.component("jti-filter-panel", JtiFilterPanel);
Vue.component("page-loading", PageLoading);
Vue.component("search-field", SearchField);
Vue.component("m-icon", IconBase);
Vue.component("icon-home", IconHome);
Vue.component("icon-company", IconCompany);
Vue.component("icon-access-card", IconAccessCard);
Vue.component("icon-employee", IconEmployee);
Vue.component("icon-device", IconDevice);
Vue.component("icon-terminal", IconTerminal);
Vue.component("icon-fuel-station", IconFuelStation);
Vue.component("icon-route", IconRoute);
Vue.component("icon-bus-type", IconBusType);
Vue.component("icon-vehicle", IconVehicle);
Vue.component("icon-project", IconProject);
Vue.component("icon-stop", IconStop);
Vue.component("icon-passenger-type", IconPassengerType);
Vue.component("icon-schedule", IconSchedule);
Vue.component("icon-seats", IconSeats);
Vue.component("icon-layout", IconLayout);

Vue.component("icon-blank", IconBlank);
Vue.component("icon-seat", IconSeat);
Vue.component("icon-driver", IconDriver);
Vue.component("icon-door", IconDoor);
Vue.component("icon-toilet", IconToilet);

Vue.component("filter-panel", NewJtiFilterPanel);

sync(store, router);

new Vue({
  router,
  store,
  // vuetify,
  render: h => h(App)
}).$mount("#app");
